import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { tableClass } from './styles';
import Checkbox from './Checkbox';
import { getDirectionX } from '../utils/dom/translate';
export var CLASS_FIXED_LEFT = 'fixed-left';
export var CLASS_FIXED_RIGHT = 'fixed-right';
var DefaultProps = {
  fixed: '',
  style: {},
  align: 'left'
};

var Td =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Td, _PureComponent);

  var _super = _createSuper2(Td);

  function Td(props) {
    var _this;

    _classCallCheck(this, Td);

    _this = _super.call(this, props);
    _this.cachedRender = void 0;
    _this.handleExpandClick = _this.handleExpandClick.bind(_assertThisInitialized(_this));
    _this.handleTreeExpand = _this.handleTreeExpand.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Td, [{
    key: "handleExpandClick",
    value: function handleExpandClick() {
      var _this$props = this.props,
          originKey = _this$props.originKey,
          expanded = _this$props.expanded,
          data = _this$props.data,
          expandKeys = _this$props.expandKeys,
          expandClick = _this$props.expandClick,
          resetFixAuto = _this$props.resetFixAuto;

      if (expandKeys) {
        if (expandClick) expandClick(data, !expanded);
      } else {
        this.props.onExpand(originKey, expanded ? undefined : this.cachedRender);
      }

      resetFixAuto(true);
    }
  }, {
    key: "handleTreeExpand",
    value: function handleTreeExpand() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          onTreeExpand = _this$props2.onTreeExpand,
          index = _this$props2.index;
      onTreeExpand(data, index);
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox() {
      var _this$props3 = this.props,
          index = _this$props3.index,
          data = _this$props3.data,
          datum = _this$props3.datum,
          treeColumnsName = _this$props3.treeColumnsName,
          treeCheckAll = _this$props3.treeCheckAll,
          disabled = _this$props3.disabled,
          render = _this$props3.render;
      var checkbox =
      /*#__PURE__*/
      React.createElement(Checkbox, {
        force: datum.check(data),
        data: data,
        index: index,
        datum: datum,
        disabled: disabled,
        treeColumnsName: treeCheckAll ? treeColumnsName : undefined
      });

      if (render && typeof render === 'function') {
        return render(data, index, checkbox);
      }

      return checkbox;
    }
  }, {
    key: "renderExpand",
    value: function renderExpand(index) {
      var _this$props4 = this.props,
          expanded = _this$props4.expanded,
          render = _this$props4.render,
          data = _this$props4.data;
      if (typeof render !== 'function') return null;

      var _cachedRender = render(data, index);

      if (!_cachedRender) return null;

      if (typeof _cachedRender !== 'function') {
        _cachedRender = function cachedRender() {
          return _cachedRender;
        };
      }

      this.cachedRender = _cachedRender;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: tableClass('expand-indicator', "icon-expand-".concat(expanded ? 'sub' : 'plus')),
          onClick: this.handleExpandClick
        })
      );
    }
  }, {
    key: "renderTreeExpand",
    value: function renderTreeExpand(content) {
      var _this$props5 = this.props,
          data = _this$props5.data,
          treeRoot = _this$props5.treeRoot,
          treeColumnsName = _this$props5.treeColumnsName,
          treeExpand = _this$props5.treeExpand,
          originKey = _this$props5.originKey,
          treeExpandLevel = _this$props5.treeExpandLevel,
          treeIndent = _this$props5.treeIndent,
          treeEmptyExpand = _this$props5.treeEmptyExpand;
      var level = treeExpandLevel.get(originKey) || 0;
      var className = tableClass('expand-wrapped');

      if (!treeColumnsName || !data[treeColumnsName] || data[treeColumnsName].length === 0 && !treeEmptyExpand) {
        return (
          /*#__PURE__*/
          React.createElement("span", {
            className: className,
            style: {
              marginLeft: level * treeIndent,
              paddingLeft: treeRoot ? 0 : 25
            }
          }, content)
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: className,
          style: {
            marginLeft: level * treeIndent
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          key: "expand-icon",
          onClick: this.handleTreeExpand,
          className: tableClass('icon-tree-expand', "icon-tree-".concat(treeExpand ? 'sub' : 'plus'))
        }), content)
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      var _this$props6 = this.props,
          render = _this$props6.render,
          data = _this$props6.data,
          index = _this$props6.index,
          treeColumnsName = _this$props6.treeColumnsName,
          treeExpandShow = _this$props6.treeExpandShow;
      var content = typeof render === 'function' ? render(data, index) : data[render];
      if (!treeColumnsName || !treeExpandShow) return content;
      return this.renderTreeExpand(content);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props7 = this.props,
          type = _this$props7.type,
          index = _this$props7.index;

      switch (type) {
        case 'checkbox':
          return this.renderCheckbox();

        case 'expand':
        case 'row-expand':
          return this.renderExpand(index);

        default:
          return this.renderResult();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          rowSpan = _this$props8.rowSpan,
          colSpan = _this$props8.colSpan,
          fixed = _this$props8.fixed,
          _this$props8$style = _this$props8.style,
          style = _this$props8$style === void 0 ? {} : _this$props8$style,
          firstFixed = _this$props8.firstFixed,
          lastFixed = _this$props8.lastFixed,
          type = _this$props8.type,
          align = _this$props8.align,
          ignoreBorderRight = _this$props8.ignoreBorderRight,
          offsetLeft = _this$props8.offsetLeft,
          offsetRight = _this$props8.offsetRight;
      var className = classnames(this.props.className, tableClass(fixed === 'left' && CLASS_FIXED_LEFT, fixed === 'right' && CLASS_FIXED_RIGHT, firstFixed && 'fixed-first', lastFixed && 'fixed-last', (type === 'checkbox' || type === 'expand' || type === 'row-expand') && 'checkbox', align !== 'left' && "align-".concat(align), ignoreBorderRight && 'ignore-right-border'));

      var newStyle = _objectSpread2({}, style);

      if (fixed === 'left' && offsetLeft) {
        newStyle.transform = "translateX(".concat(getDirectionX("".concat(offsetLeft, "px")), ")");
      }

      if (fixed === 'right' && offsetRight) {
        newStyle.transform = "translateX(".concat(getDirectionX("-".concat(offsetRight, "px")), ")");
      }

      return (
        /*#__PURE__*/
        React.createElement("td", {
          style: newStyle,
          className: className,
          rowSpan: rowSpan,
          colSpan: colSpan
        }, this.renderContent())
      );
    }
  }]);

  return Td;
}(PureComponent);

Td.defaultProps = DefaultProps;
export default Td;